var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "mSaveCalcPersonalAccountTransactions",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
      },
      on: {
        show: _vm.onShowModal,
        close: function ($event) {
          _vm.localActive = false
        },
      },
      model: {
        value: _vm.localActive,
        callback: function ($$v) {
          _vm.localActive = $$v
        },
        expression: "localActive",
      },
    },
    [
      _c("div", { staticClass: "m-personal-account" }, [
        _c(
          "svg",
          {
            staticClass: "m-personal-account-close",
            attrs: {
              width: "15",
              height: "16",
              viewBox: "0 0 15 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
            on: {
              click: function ($event) {
                _vm.localActive = false
              },
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                fill: "#8E9CBB",
              },
            }),
            _c("path", {
              attrs: {
                d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                fill: "#8E9CBB",
              },
            }),
          ]
        ),
        _c("div", { staticClass: "m-personal-account-title" }, [
          _vm._v("Операции с личным счетом"),
        ]),
        _c("div", { staticClass: "position-relative" }, [
          _c("div", {
            staticClass: "m-personal-account-form-shadow-top",
            attrs: { id: "m-personal-account-form-shadow-top" },
          }),
          _c(
            "div",
            {
              staticClass: "m-personal-account-form",
              class: {
                "m-personal-account-form-scrolled":
                  _vm.personalAccountTransactionsItems.length > 100,
              },
              attrs: { id: "m-personal-account-form" },
              on: { scroll: _vm.setShadowsOnScroll },
            },
            _vm._l(
              _vm.personalAccountTransactionsItems,
              function (item, index) {
                return _c(
                  "div",
                  {
                    key: `personal-transaction-${index}`,
                    staticClass: "m-personal-account-form-item",
                    class: {
                      "m-personal-account-form-item-required":
                        item.amountLocalError.length > 0,
                    },
                  },
                  [
                    _c("c-switcher", {
                      staticClass: "m-personal-account-form-item-switcher",
                      class: {
                        "m-personal-account-form-item-switcher-red":
                          item.switcherLocal === "writeOff",
                        "m-personal-account-form-item-switcher-green":
                          item.switcherLocal === "charge",
                      },
                      attrs: {
                        type: "group",
                        items: [
                          { label: "Списать", value: "writeOff" },
                          { label: "Начислить", value: "charge" },
                        ],
                      },
                      model: {
                        value: item.switcherLocal,
                        callback: function ($$v) {
                          _vm.$set(item, "switcherLocal", $$v)
                        },
                        expression: "item.switcherLocal",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "m-personal-account-form-item-summ",
                        class: {
                          "m-personal-account-form-item-summ-required":
                            item.amountLocalError.length > 0,
                        },
                      },
                      [
                        _c("c-input", {
                          staticClass:
                            "m-personal-account-form-item-summ-input",
                          attrs: {
                            "input-text-condition": item.amountLocalError,
                            placeholder: "0",
                            type: "number",
                          },
                          model: {
                            value: item.amountLocal,
                            callback: function ($$v) {
                              _vm.$set(item, "amountLocal", $$v)
                            },
                            expression: "item.amountLocal",
                          },
                        }),
                        _vm._v(" ฿ "),
                      ],
                      1
                    ),
                    _c("c-select", {
                      staticClass: "m-personal-account-form-item-row-basis",
                      attrs: {
                        type: "select",
                        label: "",
                        clearable: true,
                        required: false,
                        searchable: true,
                        items: _vm.personalListForRecord(item, index),
                        placeholder: "Выберите причину",
                      },
                      model: {
                        value: item.reasonLocal2,
                        callback: function ($$v) {
                          _vm.$set(item, "reasonLocal2", $$v)
                        },
                        expression: "item.reasonLocal2",
                      },
                    }),
                    _vm.personalAccountTransactionsItems.length > 1
                      ? _c("c-button", {
                          key: `remove-${index}-desktop`,
                          staticClass:
                            "m-personal-account-form-item-trash-desktop",
                          attrs: {
                            title: "Удалить",
                            size: "iconic",
                            icon: "trash",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removePersonalAccountTransactionItem(
                                index
                              )
                            },
                          },
                        })
                      : _vm._e(),
                    _vm.personalAccountTransactionsItems.length > 1
                      ? _c("c-button-2", {
                          key: `remove-${index}-mobile`,
                          staticClass:
                            "m-personal-account-form-item-trash-mobile",
                          attrs: {
                            label: "Удалить",
                            title: "Удалить",
                            size: "small",
                            icon: {
                              icon: "trash",
                              color: "secondary",
                            },
                          },
                          on: {
                            click: _vm.removePersonalAccountTransactionItem,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }
            ),
            0
          ),
          _c("div", {
            staticClass: "m-personal-account-form-shadow-bottom",
            staticStyle: { display: "none" },
            attrs: { id: "m-personal-account-form-shadow-bottom" },
          }),
        ]),
        _c(
          "div",
          { staticClass: "m-personal-account-result" },
          [
            _c("c-button-2", {
              attrs: {
                size: "small",
                label: "Добавить",
                icon: {
                  icon: "plus",
                  color: "blue",
                },
              },
              on: { click: _vm.addPersonalAccountTransactionItem },
            }),
            _c("div", { staticClass: "m-personal-account-result-total" }, [
              _c(
                "div",
                { staticClass: "m-personal-account-result-total-title" },
                [
                  _vm._v(" Итого: "),
                  _c(
                    "span",
                    {
                      staticClass: "m-personal-account-result-total-sum",
                      class: {
                        "m-personal-account-result-total-sum-green":
                          _vm.totalSum > 0,
                        "m-personal-account-result-total-sum-red":
                          _vm.totalSum < 0,
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.totalSum) + " ฿ ")]
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "m-personal-account-actions" },
          [
            _c("c-button", {
              staticClass: "m-personal-account-actions-cancel",
              attrs: { size: "large", label: "Отменить" },
              on: { click: _vm.cancel },
            }),
            _c("c-button", {
              staticClass: "m-personal-account-actions-save",
              attrs: { label: "Сохранить", color: "primary", size: "large" },
              on: { click: _vm.submitForm },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }